module.exports = __webpack_public_path__ + "static/deer-80b2de52c35eb457e5092ead2dfc6ffe.mp4";